import React from 'react';
import CrudTable from '../table/crudtable'
import { userService } from '../../_services'
import UserForm from './userform.component'
import { useTranslation } from "react-i18next";
import MultipleUserForm from './multipleuserform.component'

function User() {

    const {t} = useTranslation('common');

    const initialState = {
		customer: -1,
		parent: '',
		username: '',
		password: '',
		email: '',
		fullName: '',
		enabled: true,
		accountExpired: false,
		accountLocked: false,
		passwordExpired: false,
		twoFactorAuthenticationType: 'NONE',
		userRoles: [],
		userLicenses: [],
		parent: null
    }

	const formatBoolean = function(cell) {
		return cell ? t('crudtable.yes') : t('crudtable.no')
	}

	const formatUserRoles = function(cell) {
		if (cell && cell.length > 0) {
			return cell.map(userRole => userRole.roleAuthority).join(', ')
		}
		return '-'
	}

	const formatUserLicenses = function(cell) {
		if (cell && cell.length > 0) {
			return cell.map(userLicense => userLicense.licenseCode).join(', ')
		}
		return '-'
	}

	const formatTwoFactorAuthentication = function(cell) {
		console.log(cell)
		if (cell == 'TOTP') {
			return 'TOTP'
		} else if (cell == 'EMAIL') {
			return 'E-post'
		}
		return '-'
	}

    const columns = [
		{
	        dataField: 'username',
	        text: t('user.columns.username'),
	        sort: true
        },
        {
			dataField: 'customerName',
		    text: t('user.columns.customer'),
		    sort: true
        },
        {
	        dataField: 'enabled',
	        text: t('user.columns.enabled'),
	        sort: true,
	        formatter: formatBoolean,
	        filterValue: formatBoolean
	    },
	    {
	        dataField: 'userRoles',
	        text: t('user.columns.roles'),
	        sort: true,
	        formatter: formatUserRoles,
	        filterValue: formatUserRoles
	    },
	    {
	        dataField: 'userLicenses',
	        text: t('user.columns.licenses'),
	        sort: true,
	        formatter: formatUserLicenses,
	        filterValue: formatUserLicenses
	    },
	    {
	        dataField: 'twoFactorAuthenticationType',
	        text: t('user.columns.twofactorauthentication'),
	        sort: true,
	        formatter: formatTwoFactorAuthentication,
	        filterValue: formatTwoFactorAuthentication
        },
	    {
	        dataField: 'parentUsername',
	        text: t('user.columns.parent'),
	        sort: true,
	        formatter: cell => cell || '-'
        }
    ]

    return (
		<div>
            <h2>
                {t('user.label')}
            </h2>
            <CrudTable
                service={userService}
                columns={columns}
                initialState={initialState}
		        form={<UserForm/>}
                remote={{"filter": false, "search": false, "pagination": false}}
                sort={{dataField: 'username', order: 'asc'}}
                modalSize="lg"
                urlParams={true}
                buttons={[<MultipleUserForm key={'MultipleUserForm'}/>]}
            />
        </div>
    )
}

export default User;